/**
 * Admin-authored, generic multi-step conversation flow library, shared by
 * the API and the web client. Kept in sync with
 * apps/api/src/modules/automation-flows/automation-flows.schemas.ts.
 *
 * Platform-wide (not tenant-scoped) - same "global catalogue" shape as
 * `AutomationTemplate`. A `START_FLOW` automation action's `flowKey`
 * references one of these by `key`.
 *
 * A flow is a small directed graph: `startStepId` plus a map of
 * `stepId -> step`. Every step is one of a fixed palette (`FlowStepKind`) -
 * a "smart building block" the interpreter knows how to execute, not
 * free-form code. `"__END__"` is a reserved step-id sentinel meaning "end the
 * flow here, no further message" - usable as any transition target without
 * needing a dedicated `END` step.
 */
export const FLOW_END_SENTINEL = '__END__';
//# sourceMappingURL=automation-flows.js.map